import './LayoutGap.css';

const LayoutGap: React.FC = () => {
    return (
        <div className="layout-gap"></div>
    )
}

export default LayoutGap